@import '~@s-ui/theme/lib/settings-compat-v7/index';
@import '~@s-ui/theme/lib/index';
@import '~@adv-mt/mt-theme/lib/motor';

@import '~@adv-mt/mt-card-appraisal/lib/index';
@import '~@adv-mt/mt-card-message/lib/index';
@import '~@adv-mt/mt-form-conditions-and-privacy-checkbox/lib/index';
@import '~@adv-mt/mt-form-sell-vehicle/lib/index';
@import '~@adv-mt/mt-form-user-contact/lib/index';
@import '~@adv-mt/mt-hero-basic/lib/index';
@import '~@adv-mt/mt-layout-basic/lib/index';
@import '~@adv-mt/mt-list-basic/lib/index';
@import '~@adv-mt/mt-markdown-wrapper/lib/index';
@import '~@adv-mt/mt-navigation-breadcrumb/lib/index';
@import '~@adv-mt/mt-panel-market-players/lib/index';
@import '~@adv-mt/mt-svg-icons/lib/index';
@import '~@adv-mt/mt-title-basic/lib/index';
@import '~@s-ui/react-atom-button/lib/index';
@import '~@s-ui/react-atom-icon/lib/index';
@import '~@s-ui/react-atom-image/lib/index';
@import '~@s-ui/react-form-builder/lib/index';
@import '~@s-ui/react-layout-grid/lib/index';
@import '~@s-ui/react-molecule-accordion/lib/index';
@import '~@s-ui/react-molecule-notification/lib/index';
@import '~@s-ui/react-molecule-quick-action/lib/index';

@import '../components/AppraiserHero/index.scss';
@import '../components/AppraiserForm/index.scss';
@import '../components/PanelBenefits/index.scss';
@import '../components/ListHowWeDoIt/index.scss';
@import '../components/RecommendedPriceCard/index.scss';
@import '../components/SellOptionsBlock/index.scss';
@import '../components/ParticularSellerBenefits/index.scss';
@import '../../../PublishYourAd/components/PageContent/components/OptionComparator/index.scss';
@import '../../../InstantOffer/components/StepFormPlateRequired/index.scss';

$g-mt-vehicle-appraiser-form-and-benefit: 72px;
$fz-mt-vehicle-appraiser-appraisalStepSection-title: 32px;

$mw-mt-vehicle-appraiser-form: 456px;

.mt-VehicleAppraiserPage {
  margin-bottom: $m-xxl;
  position: relative;

  &-listHowWeDoItSection {
    @include media-breakpoint-up(l) {
      margin-top: $mt-mt-vehicle-appraiser-listHowWeDoIt;
    }
  }

  &-appraisalStepSection {
    display: flex;
    flex-direction: column;
    gap: $g-xxxl;
  }

  &-formAndBenefitsSection {
    display: grid;
    grid-template-columns: 1fr;
    gap: $g-mt-vehicle-appraiser-form-and-benefit;
    padding: $p-xl 0;

    @include media-breakpoint-up(l) {
      grid-template-columns: 1fr 1fr;
    }
  }

  &-appraisalStepSectionTitle {
    font-size: $fz-mt-vehicle-appraiser-appraisalStepSection-title;
  }

  &-breadcrumb {
    margin-left: -$m-xl;
  }
}
